const Texts = {
  baseStyle: {
    color: "black",
    fontFamily: "body",
  },
  variants: {
    base: {
      color: "black",
      fontSize: ["sm", "md", "lg", "xl", "xl"],
    },
    subtext: {
      color: "white",
      fontWeight: "subtextWeight",
      opacity: 0.75,
    },
    card: {
      color: "black",
      fontSize: "sm",
    },
    register: {
      color: "black",
      fontSize: "xl",
      fontStyle: "italic",
    },
    table: {
      color: "black",
      fontSize: ["xs", "xs", "xs", "xs", "sm"],
    },
  },
}

export default Texts
